import React, { Component } from 'react';
import {
  Button,
  ButtonGroup,
  Container,
  Col,
  Row,
  Table,
  Input,
} from 'reactstrap';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import FontAwesome from 'react-fontawesome';

import Loan from './widgets/Loan';

class AllLoans extends Component {
  state = {
    file: '',
    loans: '',
    loadmore: true,
    filtered: '',
    type: 'All',
    colorSheet: 'dark',
    text: 'sheet?',
    csvData: null,
    loading: false,
  };

  handleImage = (e) => {
    if (
      window.confirm(
        'Are you sure the payroll sheet you are upload is valid. Please crosscheck all values.',
      )
    ) {
      this.setState({ colorSheet: 'warning', text: 'Loading.. Please wait!!' });

      const docdata = new FormData();
      docdata.append('file', e.target.files[0]);
      axios
        .post('/api/uploadRepayment/check/amount/loanid', docdata, {headers:{ Authorization: localStorage.getItem('token') } })
        .then(({ data }) => {
          //  console.log(data);
          let i = 0;
          let err = false;
          for (i; i < data.length; i++) {
            if (data[i]['Loan Amount'] && data[i].Repayment && data[i].LoanId) {
              if (
                isNaN(data[i]['Loan Amount'])
                || isNaN(data[i].Repayment)
                || isNaN(data[i].LoanId)
              ) {
                err = true;
                alert(
                  `Only pass numbers for Loan Amount, loanid and Repayment. please check this data ->${
                    data[i]['Loan Amount']
                  },${data[i].LoanId} and ${data[i].Repayment}`,
                );

                break;
              }
            } else {
              err = true;
              alert(
                'Make sure you add Loan Amount, loanid and Repayment. please check',
              );
              break;
            }
          }
          if (i == data.length && !err) {
            data.map((dat) => {
              axios
                .post(
                  `/api/uploadRepayment/repay/${dat.Repayment}/${dat.LoanId}`,{}, {headers:{ Authorization: localStorage.getItem('token') } }
                )
                .then(({ data }) => {
                  this.setState({
                    colorSheet: 'success',
                    text: `${data.length} repayment uploaded`,
                  });
                  // console.log(data);
                })
                .catch((err) => {
                  this.setState({
                    colorSheet: 'danger',
                    text:
                      'An Error occured. please confirm the sheet. some payment might have gone through!!',
                  });
                  console.log(err.response);
                });
            });
          }
          // this.setState({ colorSheet: 'success', text:'Payroll Done. Please Check Lendlot' });
        })
        .catch((err) => {
          console.log(err.response);
          this.setState({ colorSheet: 'danger', text: 'Error!!' });
        });
    }
  };

  componentWillMount() {
    this.setState({ loadmore: true }, async () => {
      try {
        const loans = await this.getLoans(5, 0, 'desc');
        // console.log(loans);
        this.setState({ loans, loadmore: false });
      } catch (error) {
        console.error(error);
      }
    });
  }


  getLoans = (limit = 5, skip = 0, order = 'asc', list = '') => axios
    .get(`/api/getLoans?limit=${limit}&skip=${skip}&order=${order}`, {headers:{ Authorization: localStorage.getItem('token') } })
    .then((response) => {
      if (list) {
        return [...list, ...response.data];
      }

      return response.data;
    })
    .catch((err) => { });

  renderLoans = loans => (loans
    ? loans.map((item, i) => (
      <Loan
        close={this.closeLoan}
        delete={this.deleteLoan}
        {...this.props}
        {...item}
        no={i + 1}
        key={item._id}
      />
    ))
    : null);

    closeLoan = (loanId) => {
      if (window.confirm('You cannot undo this! Please be sure')) {
        this.setState({ loadmore: true });

        axios
          .get(`/api/closeLoan/${loanId}`, {headers:{ Authorization: localStorage.getItem('token') } })
          .then(async ({ data }) => {
            try {
              const loans = await this.getLoans(5, 0, 'desc');
              this.setState({ loans, loadmore: false });
            } catch (error) {
              console.error(error);
            }
          })
          .catch((err) => {
            window.alert('Failed to delete ');
            console.log(err.response);
          });
      } else {
        alert('cancelled');
      }
    };

  deleteLoan = (loanId) => {
    if (window.confirm('You cannot undo this! Please be sure')) {
      this.setState({ loadmore: true });

      axios
        .delete(`/api/deleteLoan/${loanId}`, {headers:{ Authorization: localStorage.getItem('token') } })
        .then(async ({ data }) => {
          try {
            const loans = await this.getLoans(5, 0, 'desc');
            this.setState({ loans, loadmore: false });
          } catch (error) {
            console.error(error);
          }
        })
        .catch((err) => {
          window.alert('Failed to delete ');
          console.log(err.response);
        });
    } else {
      alert('cancelled');
    }
  };

  getEligibilitys = async () => {
    this.setState({ loading: true });
    const data = await axios.get('/api/getEligibilitys', {headers:{ Authorization: localStorage.getItem('token') } });
    this.setState({ csvData: data.data, loading: false });
    // console.log(this.state.csvData);
  };

  filterLoans = (status) => {
    let type;
    if (status === 1) {
      type = 'Unapproved';
    } else if (status === 5) {
      type = 'Approved';
    } else if (status === 3) {
      type = 'Modification Requested';
    } else if (status === 7) {
      type = 'Disbursed';
    } else if (status === 9) {
      type = 'Rejected';
    }
    const filtered = this.state.loans.filter(item => item.status === status);
    this.setState({ filtered, type });
  };

  loadmore = () => {
    this.setState({ loadmore: true }, async () => {
      try {
        const count = this.state.loans.length;
        const loans = await this.getLoans(
          count + 5,
          count,
          'desc',
          this.state.loans,
        );

        this.setState({ loans, loadmore: false });
      } catch (error) {
        console.error(error.response);
      }
    });
  };

  render() {
    return (
      <Container>
        <Row>
          {/* <Col className="my-3" md={12}>
            {this.state.csvData ? (
              <CSVLink
                data={this.state.csvData}
                filename={`applications_${new Date().toISOString()}.csv`}
                target="_blank"
              >
                {' '}
                <Button className="btn btn-info btn-sm">Download Applications</Button>
              </CSVLink>

            ) : <Button disabled={this.state.loading} onClick={this.getEligibilitys} className="btn btn-danger btn-sm">{this.state.loading ? 'Please Wait' : 'Get Applications'}</Button>}
            <h2 className="text-center">
              {this.state.type}
              {' '}
Loans
            </h2>
            {' '}
          </Col> */}
          <Row className="w-100 text-center mb-1 mt-4">
            <Col xs={12} md={12}>
              <ButtonGroup>
                <Button
                  onClick={() => {
                    this.filterLoans(1);
                  }}
                  color="info"
                >
                  Unapproved
                </Button>
                <Button
                  onClick={() => {
                    this.filterLoans(5);
                  }}
                  color="success"
                >
                  Approved
                </Button>
                {/* <Button onClick={() => { this.filterLoans(3); }} color="secondary">Requesting Modification</Button> */}
                <Button
                  onClick={() => {
                    this.filterLoans(7);
                  }}
                  color="primary"
                >
                  Disbursed
                </Button>
                <Button
                  onClick={() => {
                    this.filterLoans(9);
                  }}
                  color="danger"
                >
                  Rejected
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Col md={12}>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Client Id</th>
                  <th>Loan Id</th>
                  <th>Loan Amount</th>
                  {/* <th>Loan Account</th> */}
                  {/* <th>Repayment Type</th> */}
                  <th>Loan Tenure</th>
                  <th>Submitted On</th>
                  <th>Is Topup</th>
                  <th />
                  <th />
                  {/* <th>
                    {' '}
                    {this.props.user.employer == 'CHECKOFF' ? (
                      <label
                        className={`btn btn-${this.state.colorSheet} btn-sm`}
                        htmlFor="file"
                      >
                        {this.state.text}
                        <Input
                          type="file"
                          onChange={this.handleImage}
                          name="file"
                          style={{ display: 'none' }}
                          id="file"
                          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                        />
                      </label>
                    ) : null}
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {this.renderLoans(
                  this.state.filtered ? this.state.filtered : this.state.loans,
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="mx-auto my-3 text-center">
            {this.state.loadmore ? (
              <FontAwesome
                name="spinner"
                size="2x"
                style={{ color: '#c82590' }}
                spin
              />
            ) : (
              <Button onClick={this.loadmore} outline block color="warning">
                  Load More
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AllLoans;
